export default "__VITE_ASSET__076237b1__"